<header>
    <div class="p-3 header">
        <a><img src="assets/icons/menu_offset_gray_24dp.svg"></a>
        <!--<a class="float-end" (click)="logout()"><img src="assets/icons/person_gray_24dp.svg"></a>-->
        <button class="btn btn-secondary btn-sm float-end" (click)="logout()">{{'basic.logOut' | translate}}</button>
    </div>
    
</header>

